module.exports = __webpack_public_path__ + "toBride1-jp-w-w.21399578.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-jp-w-w.jpg
// module id = aNkr
// module chunks = 0